import { CurrencyList } from '@common/enums/Currency';
import { IOnInit } from 'angular';
import {ReportsRepo} from '@services/reports.repo'
import * as moment from 'moment'
import { extractErrorMessage } from '@common/utils/errorUtils';

class CustodianReportDialog implements IOnInit{

  public clientPortfolios;

  public reportDate;

  public clientNumber;

  public currencyList = CurrencyList;

  private attachmentsControl: HTMLInputElement;
  public files: FileList;

  public selectedFile;

  public selectedCurrency;

  public selectedPortfolio;

  public selectedReportType: string = "bankStatement";

  public reportName: string = "";

  public isLoading: boolean = false;

  public selectedFileName: string = "";

  public generatedName: string = "";

  /** @ngInject */
  constructor(private $mdDialog: angular.material.IDialogService, private notifyjs, private $scope: angular.IScope,
     private $timeout: angular.ITimeoutService, private reportsRepo : ReportsRepo) {

  }

  $onInit(){
    let that = this;

    this.$timeout(() => {
      that.attachmentsControl = document.getElementById('attachments') as HTMLInputElement;
      that.attachmentsControl.addEventListener('change', that.onFilesSelected.bind(that));
    },1000);

    // Watch for changes in portfolio and currency to update generated name
    this.$scope.$watch(() => this.selectedPortfolio, () => {
      this.updateGeneratedName();
    });
    this.$scope.$watch(() => this.selectedCurrency, () => {
      this.updateGeneratedName();
    });
    this.$scope.$watch(() => this.selectedReportType, () => {
      this.updateGeneratedName();
    });

  }

  private updateGeneratedName = () => {
    if (this.selectedReportType === 'bankStatement' && this.selectedPortfolio && this.selectedCurrency) {
      // Convert to number for comparison since md-select may return string
      const portfolioId = Number(this.selectedPortfolio);
      const portfolio = this.clientPortfolios.find((p: any) => Number(p.id) === portfolioId);
      if (portfolio && portfolio.accounts && portfolio.accounts.length > 0) {
        // Use the first account (matching backend behavior)
        const account = portfolio.accounts[0];
        let accountSourceName = account.accountSourceName;
        
        // Map account source names to match backend logic
        if (!accountSourceName) {
          accountSourceName = "Confident";
        } else if (accountSourceName === "MCB") {
          accountSourceName = "MCB";
        } else if (accountSourceName === "Rothschild") {
          accountSourceName = "EDR";
        }
        
        this.generatedName = `${accountSourceName} ${account.accountNumber} (${this.selectedCurrency}) Report`;
      } else {
        this.generatedName = "";
      }
    } else {
      this.generatedName = "";
    }
  }

  private onFilesSelected(event) {
    this.files = event.target.files;
    if (this.files && this.files.length > 0) {
      this.selectedFileName = this.files[0].name;
    } else {
      this.selectedFileName = "";
    }
    this.$scope.$apply();
  }

  public openFileDialog = () => {
    if (!this.attachmentsControl) {
      this.attachmentsControl = document.getElementById('attachments') as HTMLInputElement;
      if (this.attachmentsControl) {
        this.attachmentsControl.addEventListener('change', this.onFilesSelected.bind(this));
      }
    }
    if (this.attachmentsControl) {
      this.attachmentsControl.click();
    }
  }

  cancel = () => {
    this.$mdDialog.hide();
  }

  public uploadReport = () => {
    this.isLoading = true;
    const formData = new FormData();

    // Only append portfolio and currency for bank statements
    if (this.selectedReportType === 'bankStatement') {
      formData.append('portfolioId', this.selectedPortfolio)
      formData.append('currency', this.selectedCurrency)
    }

    // Always append clientNumber for both types
    if (this.clientNumber) {
      formData.append('clientNumber', this.clientNumber)
    }

    // Append name if provided (for both bank statements and generic reports)
    if (this.reportName && this.reportName.trim().length > 0) {
      formData.append('name', this.reportName.trim())
    }

    let reportDate = moment(this.reportDate).endOf('month').format("YYYY-MM-DD")
    formData.append('reportDate', reportDate)

    Array.from(this.attachmentsControl.files).forEach(file => formData.append('attachment', file))

    this.reportsRepo.uploadCustodianReport(formData)
      .then(() => {
        this.$mdDialog.hide(true);
      })
      .catch((err) => {
        this.notifyjs("Failed to upload custodian report: " + extractErrorMessage(err, "Unknown error"), "error");
      })
      .finally(() => {
        this.isLoading = false;
      });
  }


  isFormValid = () => {
    const hasFile = this.selectedFileName && this.selectedFileName.length > 0;
    const hasFileInControl = this.attachmentsControl && this.attachmentsControl.files && this.attachmentsControl.files.length > 0;
    
    // For bank statements, require portfolio and currency
    if (this.selectedReportType === 'bankStatement') {
      return this.selectedCurrency && this.selectedPortfolio && (hasFile || hasFileInControl);
    }
    
    // For generic reports, require file and name
    const hasName = this.reportName && this.reportName.trim().length > 0;
    return hasName && (hasFile || hasFileInControl);
  }




}


export const custodianReportDialog: angular.IComponentOptions = {
  template: require('./custodianReport.dialog.html'),
  controller: CustodianReportDialog,
  bindings : {
    clientPortfolios : "<",
    reportDate : "<",
    clientNumber : "<"
  }
}



// WEBPACK FOOTER //
// ./src/app/portfolioadmin/reportManagement/custodianReportDialog/custodianReport.dialog.ts